// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"cdfeb1b5","398":"0f799bb6","624":"780d7ef0"}[chunkId] + ".chunk.css";
};